"use strict";
import Account from "./account";
import CarrierInvoices from "./carrier_invoices";
import Documents from "./documents";
import DocumentPages from "./document_pages";
import DocumentBatches from "./document_batches";
import Email from "./email";
import ExceptionEvents from "./exception_events";
import ExceptionedItems from "./exceptioned_items";
import Rules from "./rules";
import FactoringCompanies from "./factoring_companies";
import FactoringAssignments from "./factoring_assignments";
import FactorInvoices from "./factor_invoices";
import DropTracker from "./drop_tracker";
import Verifications from "./verifications";
import LoadShipments from "./load_shipments";
export default {
  Account,
  CarrierInvoices,
  Documents,
  DocumentPages,
  DocumentBatches,
  Email,
  ExceptionEvents,
  ExceptionedItems,
  FactoringCompanies,
  Rules,
  FactoringAssignments,
  FactorInvoices,
  DropTracker,
  Verifications,
  LoadShipments
};
